import ngTranslate from 'angular-translate';
import uiRouter from '@uirouter/angularjs';
import ngFileUpload from 'ng-file-upload';
import assign from 'lodash/assign';

import { SegmentServiceModule } from 'services/tracking/segment/segment.service';
import { CSVReaderService } from 'services/utilities/csvReader.service';
import { ChangePlanButtonModule } from 'components/changePlan/changePlanButton';

import { BulkImportProgressModal } from './bulkImportProgressModal.component';
import template from './bulkImportFileSelectModal.html';
import './bulkImport.scss';

export const BulkImportFileSelectModal = angular
    .module('app.pages.products.bulkImportFileSelectModal', [
        'ngMaterial',
        ngTranslate,
        uiRouter,
        ngFileUpload,
        CSVReaderService,
        ChangePlanButtonModule,
        BulkImportProgressModal,
        SegmentServiceModule
    ]).component('bulkImportModal', {
        template,
        bindings: {
            singleError: '@',
            featureLimitation: '<',
            importerType: '<',
            errorList: '<',
            refreshOnClose: '<'
        },
        controller: class BulkImportFileSelectModalController {
            constructor(
                $scope,
                $mdDialog,
                csvReader,
                $state,
                $window,
                $location,
                $mdToast,
                $translate,
                segmentService
            ) {
                'ngInject';

                assign(this, {
                    gtmid: '',
                    csvDataObject: null,
                    fileName: null,
                    fileMaxSize: '200MB',
                    isViewingErrorList: false,
                    $scope,
                    $mdDialog,
                    csvReader,
                    $state,
                    $window,
                    $location,
                    $mdToast,
                    $translate,
                    segmentService
                });
            }

            $onInit() {
                if (this.featureLimitation && this.featureLimitation.hasHitProductLimit) {
                    this.gtmid = `admin_${this.$state.current.name}_bulkImportLimitReached`;
                    this.trackPage('/bulkimport/limitreached', 'Bulk Import Limit Reached');
                } else {
                    this.gtmid = `admin_${this.$state.current.name}_bulkImportModal`;
                    this.trackPage('/bulkimport', 'Bulk Import');
                }
            }

            cancelImport() {
                this.$mdDialog.cancel('cancel');
                if (this.refreshOnClose) {
                    this.$state.reload();
                }
            }

            viewErrorReport() {
                this.isViewingErrorList = true;
            }

            cancelErrorReport() {
                this.isViewingErrorList = false;
            }

            getCSVSampleUrl() {
                switch (this.importerType) {
                    case 'product':
                        return process.env.BULK_PRODUCT_IMPORT_SAMPLE_CSV;
                    case 'order':
                        return process.env.BULK_ORDER_IMPORT_SAMPLE_CSV;
                    case 'customer':
                        return process.env.BULK_CUSTOMER_IMPORT_SAMPLE_CSV;
                    default:
                        return '';
                }
            }

            proceedImport(data, fileName) {
                return this.$mdDialog.show({
                    clickOutsideToClose: true,
                    template: `<bulk-import-progress-modal
                                   importer-type="importerType"
                                   csv-obj="csvObj"
                                   file-name="${fileName}"
                                   feature-limitation="featureLimitation">
                               </bulk-import-progress-modal>`,
                    locals: {
                        csvObj: data,
                        featureLimitation: this.featureLimitation,
                        importerType: this.importerType
                    },
                    controller: ($scope, csvObj, featureLimitation, importerType) => {
                        'ngInject';

                        $scope.csvObj = csvObj;
                        $scope.featureLimitation = featureLimitation;
                        $scope.importerType = importerType;
                    }
                });
            }

            uploadFile(files, invalidFiles) {
                if (invalidFiles && invalidFiles.length) {
                    let msg = ['ERROR.CSVVALIDATION'];
                    if (invalidFiles.some(f => f.$error === 'maxSize')) {
                        msg = ['ERROR.CSVVALIDATIONSIZE', { max: this.fileMaxSize }];
                    }
                    this.$translate(...msg).then((error) => {
                        this.$mdToast.show(this.$mdToast.simple()
                            .textContent(error)
                            .position('bottom left')
                        );
                    });
                }
                if (!files || files.length === 0) return;

                this.csvReader.getCsvData(files[0])
                    .then((data) => {
                        this.fileName = files[0].name || '';
                        this.csvDataObject = {
                            contents: data
                        };

                        if (this.importerType === 'product') {
                            this.csvDataObject.limit = this.getNumberOfRemainingProductSlots();
                            this.csvDataObject.data = this.csvDataObject.data;
                        }

                        this.gtmid = `admin_${this.$state.current.name}_bulkImportCsvSelected`;
                    });
            }

            getNumberOfRemainingProductSlots() {
                let numberOfRemainingProductSlots =
                    this.featureLimitation.productLimit - this.featureLimitation.productCount;
                return numberOfRemainingProductSlots <= 0 ? 0 : numberOfRemainingProductSlots;
            }

            isFileReady() {
                return (this.csvDataObject !== null);
            }

            iconOpacity() {
                const ACTIVE_OPACITY = 0.54;
                const INACTIVE_OPACITY = 0.2;
                return this.isFileReady() ? ACTIVE_OPACITY : INACTIVE_OPACITY;
            }

            trackDrop() {
                this.segmentService.trackGtmEvent({
                    analyticsClickEvent: `${this.gtmid}-dropCsv`
                }, {});
            }

            trackPage(pageState, pageTitle) {
                this.segmentService.trackGtmEvent({
                    analyticsClickEvent: 'virtualPageView'
                },
                {
                    virtualPage: this.$location.path() + pageState,
                    virtualTitle: pageTitle
                });
            }

            dismissErrors() {
                this.dismissedErrors = true;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/pages/products/components/bulkImportFileSelectModal.component.js